/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './action.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../add-action/add-action.component.ngfactory';
import * as i3 from '../../../../app/multi-editor/add-action/add-action.component';
import * as i4 from '../../../../app/multi-editor/shared/services/schema-keys-store.service';
import * as i5 from 'ngx-toastr';
import * as i6 from '../update-action/update-action.component.ngfactory';
import * as i7 from '../../../../app/multi-editor/update-action/update-action.component';
import * as i8 from '../delete-action/delete-action.component.ngfactory';
import * as i9 from '../../../../app/multi-editor/delete-action/delete-action.component';
import * as i10 from '@angular/common';
import * as i11 from '../../../../app/multi-editor/action/action.component';
const styles_ActionTemplateComponent:any[] = [i0.styles];
export const RenderType_ActionTemplateComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ActionTemplateComponent,data:{}});
function View_ActionTemplateComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(2,0,(null as any),
      (null as any),1,'re-addition-action',([] as any[]),(null as any),(null as any),
      (null as any),i2.View_AddActionComponent_0,i2.RenderType_AddActionComponent)),
      i1.ɵdid(3,49152,(null as any),0,i3.AddActionComponent,[i4.SchemaKeysStoreService,
          i5.ToastrService],{action:[0,'action']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n    ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.action;
    _ck(_v,3,0,currVal_0);
  },(null as any));
}
function View_ActionTemplateComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(2,0,(null as any),
      (null as any),1,'re-update-action',([] as any[]),(null as any),(null as any),
      (null as any),i6.View_UpdateActionComponent_0,i6.RenderType_UpdateActionComponent)),
      i1.ɵdid(3,49152,(null as any),0,i7.UpdateActionComponent,([] as any[]),{action:[0,
          'action']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.action;
        _ck(_v,3,0,currVal_0);
      },(null as any));
}
function View_ActionTemplateComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(2,0,(null as any),
      (null as any),1,'re-delete-action',([] as any[]),(null as any),(null as any),
      (null as any),i8.View_DeleteActionComponent_0,i8.RenderType_DeleteActionComponent)),
      i1.ɵdid(3,49152,(null as any),0,i9.DeleteActionComponent,([] as any[]),{action:[0,
          'action']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.action;
        _ck(_v,3,0,currVal_0);
      },(null as any));
}
export function View_ActionTemplateComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),11,'div',[['class',
      'form-group']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(1,16384,(null as any),0,i10.NgSwitch,([] as any[]),{ngSwitch:[0,'ngSwitch']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_ActionTemplateComponent_1)),
      i1.ɵdid(4,278528,(null as any),0,i10.NgSwitchCase,[i1.ViewContainerRef,i1.TemplateRef,
          i10.NgSwitch],{ngSwitchCase:[0,'ngSwitchCase']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_ActionTemplateComponent_2)),i1.ɵdid(7,278528,(null as any),
          0,i10.NgSwitchCase,[i1.ViewContainerRef,i1.TemplateRef,i10.NgSwitch],{ngSwitchCase:[0,
              'ngSwitchCase']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ActionTemplateComponent_3)),
      i1.ɵdid(10,278528,(null as any),0,i10.NgSwitchCase,[i1.ViewContainerRef,i1.TemplateRef,
          i10.NgSwitch],{ngSwitchCase:[0,'ngSwitchCase']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n']))],(_ck,_v) => {
    var _co:i11.ActionTemplateComponent = _v.component;
    const currVal_0:any = _co.action.actionName;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = 'Addition';
    _ck(_v,4,0,currVal_1);
    const currVal_2:any = 'Update';
    _ck(_v,7,0,currVal_2);
    const currVal_3:any = 'Deletion';
    _ck(_v,10,0,currVal_3);
  },(null as any));
}
export function View_ActionTemplateComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'re-action',
      ([] as any[]),(null as any),(null as any),(null as any),View_ActionTemplateComponent_0,
      RenderType_ActionTemplateComponent)),i1.ɵdid(1,49152,(null as any),0,i11.ActionTemplateComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const ActionTemplateComponentNgFactory:i1.ComponentFactory<i11.ActionTemplateComponent> = i1.ɵccf('re-action',
    i11.ActionTemplateComponent,View_ActionTemplateComponent_Host_0,{action:'action'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL211bHRpLWVkaXRvci9hY3Rpb24vYWN0aW9uLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3RyYXZpcy9idWlsZC9pbnNwaXJlaGVwL3JlY29yZC1lZGl0b3Ivc3JjL2FwcC9tdWx0aS1lZGl0b3IvYWN0aW9uL2FjdGlvbi5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL3RyYXZpcy9idWlsZC9pbnNwaXJlaGVwL3JlY29yZC1lZGl0b3Ivc3JjL2FwcC9tdWx0aS1lZGl0b3IvYWN0aW9uL2FjdGlvbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL211bHRpLWVkaXRvci9hY3Rpb24vYWN0aW9uLmNvbXBvbmVudC50cy5BY3Rpb25UZW1wbGF0ZUNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJmb3JtLWdyb3VwXCIgW25nU3dpdGNoXT1cImFjdGlvbi5hY3Rpb25OYW1lXCI+XG4gICAgPGRpdiAqbmdTd2l0Y2hDYXNlPVwiJ0FkZGl0aW9uJ1wiPlxuICAgICAgICA8cmUtYWRkaXRpb24tYWN0aW9uIFthY3Rpb25dPWFjdGlvbj48L3JlLWFkZGl0aW9uLWFjdGlvbj5cbiAgICA8L2Rpdj5cbiAgICA8ZGl2ICpuZ1N3aXRjaENhc2U9XCInVXBkYXRlJ1wiPlxuICAgICAgICA8cmUtdXBkYXRlLWFjdGlvbiBbYWN0aW9uXT1hY3Rpb24+PC9yZS11cGRhdGUtYWN0aW9uPlxuICAgIDwvZGl2PlxuICAgIDxkaXYgKm5nU3dpdGNoQ2FzZT1cIidEZWxldGlvbidcIj5cbiAgICAgICAgPHJlLWRlbGV0ZS1hY3Rpb24gW2FjdGlvbl09YWN0aW9uPjwvcmUtZGVsZXRlLWFjdGlvbj5cbiAgICA8L2Rpdj5cbjwvZGl2PiIsIjxyZS1hY3Rpb24+PC9yZS1hY3Rpb24+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0NJO01BQUEsd0VBQWdDO2FBQUEsbUNBQzVCO01BQUE7TUFBQTthQUFBOzBCQUFBLHVDQUF5RDtVQUFBOztJQUFyQztJQUFwQixXQUFvQixTQUFwQjs7OztvQkFFSjtNQUFBLHdFQUE4QjthQUFBLG1DQUMxQjtNQUFBO01BQUE7YUFBQTtVQUFBLDBCQUFxRDs7O1FBQW5DO1FBQWxCLFdBQWtCLFNBQWxCOzs7O29CQUVKO01BQUEsd0VBQWdDO2FBQUEsbUNBQzVCO01BQUE7TUFBQTthQUFBO1VBQUEsMEJBQXFEOzs7UUFBbkM7UUFBbEIsV0FBa0IsU0FBbEI7Ozs7b0JBUlI7TUFBQTthQUFBO1VBQUEsZUFBdUQsOENBQ25EO1VBQUE7YUFBQTtzQkFBQSxtREFFTTtVQUFBLDJCQUNOO1VBQUEsd0RBQUE7VUFBQTtjQUFBLGdDQUVNO01BQ047YUFBQTtzQkFBQSxtREFFTTtVQUFBOztJQVRjO0lBQXhCLFdBQXdCLFNBQXhCO0lBQ1M7SUFBTCxXQUFLLFNBQUw7SUFHSztJQUFMLFdBQUssU0FBTDtJQUdLO0lBQUwsWUFBSyxTQUFMOzs7O29CQ1BKO01BQUE7d0NBQUEsVUFBQTtNQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/multi-editor/action/action.component.ngfactory.ts